import { z } from "zod";

/**
 * Staff restriction and ban (0309; Luigi BL-03, Leon 2026-10-09). Who may do
 * what is decided in SQL from the verified JWT; these only shape the input.
 */

export const restrictionKindSchema = z.enum(["standard", "indefinite", "banned"]);
export type RestrictionKindInput = z.infer<typeof restrictionKindSchema>;

export const requestRestrictionSchema = z.object({
  staffId: z.string().uuid(),
  kind: restrictionKindSchema,
  reason: z.string().trim().min(3, "Say why, in a few words.").max(1000),
});
export type RequestRestrictionInput = z.infer<typeof requestRestrictionSchema>;

export const decideRestrictionSchema = z.object({
  restrictionId: z.string().uuid(),
  approve: z.boolean(),
  note: z.string().trim().max(1000).optional(),
});
export type DecideRestrictionInput = z.infer<typeof decideRestrictionSchema>;

export const liftRestrictionSchema = z.object({
  restrictionId: z.string().uuid(),
  note: z.string().trim().max(1000).optional(),
});
export type LiftRestrictionInput = z.infer<typeof liftRestrictionSchema>;

export const restrictionDurationSchema = z.object({
  days: z.number().int().min(1).max(3650),
});
export type RestrictionDurationInput = z.infer<typeof restrictionDurationSchema>;

export const restrictionAppealSchema = z.object({
  body: z.string().trim().min(3, "Write your appeal first.").max(2000),
});
export type RestrictionAppealInput = z.infer<typeof restrictionAppealSchema>;
